import {twMerge} from '../../../common/twMerge';
import {Text} from '../../atoms/Text/Text';
import {OutlinedTabItemProps, TabType} from './OutlinedTabItemProps.interface';

export function OutlinedTabItem({
  isActive,
  type = TabType.Outline,
  className,
  children,
  ...props
}: OutlinedTabItemProps) {
  return (
    <div
      className={twMerge(
        'flex h-30pxr w-fit-content cursor-pointer select-none items-center justify-center rounded-32pxr bg-transparent py-6pxr px-14pxr',
        type === TabType.Outline &&
          isActive &&
          'border-1 border-solid border-theme-solid-100 py-5pxr px-13pxr',
        type === TabType.Background &&
          isActive &&
          'bg-theme-solid-20 py-6pxr px-14pxr',
        className
      )}
      {...props}
    >
      <Text className="font-small1 text-theme-solid-100">{children}</Text>
    </div>
  );
}
